export default __webpack_public_path__ + "1768a40.png";